import oh from 'output-helpers';

let translations = {
    'sv-SE': {
        'v0.0.1.title': 'v0.0.1 - Kundtest version',
        'v0.0.1.new': 'Första versionen för feedback.',
    },
    'en-US': {
        'v0.0.1.title': 'v0.0.1 - Customer testing',
        'v0.0.1.new': 'First release for custom testing and feedback.',
    },
    prefix: 'changelog_',
};

let changelog = [
    {
        title: translate('v0.0.1.title'),
        date: '2018-10-16',
        new: [translate('v0.0.1.new')],
    },
];

oh.addDictionary(translations);

function translate(key) {
    return oh.translate(key);
}

export default changelog;



// WEBPACK FOOTER //
// ./src/changelog.js